import script from "./OTP.vue?vue&type=script&setup=true&lang=js"
export * from "./OTP.vue?vue&type=script&setup=true&lang=js"

import "./OTP.vue?vue&type=style&index=0&id=c8f7540e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8f7540e"]])

export default __exports__